import Small from 'UIComponents/elements/Small';
import FormattedDate from '../sidebar/FormattedDate';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventTimestamp(props) {
  const {
    event
  } = props;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedDate, {
        date: event.occurredTimestamp
      })
    })
  });
}